import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MongoDbService } from '@core/services/api/mongodb.service';
import { addDesign } from '@core/state/design-tool/design-tool.actions';
import { Store, select } from '@ngrx/store';
import { ToastsComponent } from '@templates/toasts/toasts.component';
import { MdbCollapseDirective } from 'mdb-angular-ui-kit/collapse';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { MdbNotificationRef, MdbNotificationService } from 'mdb-angular-ui-kit/notification';
import { Subscription } from 'rxjs';
import * as CatalogActions from '@core/state/catalog/catalog.actions';
import * as fromCatalog from '@core/state/catalog/catalog.selectors';

@Component({
  selector: 'app-edit-position-notes-modal',
  templateUrl: './edit-position-notes-modal.component.html',
  styleUrls: ['./edit-position-notes-modal.component.scss']
})
export class EditPositionNotesModalComponent {
  notes: string
  position: string
  constructor(
    public modalRef: MdbModalRef<EditPositionNotesModalComponent>,
  ) {}

  close(notes?: string): void {
    this.modalRef.close(notes)
  }
}
